<template>
  <div class="container-relatorio-filtros">
    <div class="primary--text text-selecione">
      <span>Selecione os filtros</span> »
      <label>Relação de pacientes</label>
    </div>
    <div class="container-relatorio-interno">

      <v-radio-group v-model="filtros.ortodontia" class="checkbox_row" row dense label="É da ortodontia?">
        <v-radio label="Todos" :value="null"/>
        <v-radio label="Sim" :value="true"/>
        <v-radio label="Não" :value="false"/>
      </v-radio-group>
      <v-radio-group v-model="filtros.implante" class="checkbox_row" row dense label="Possui Implante?">
        <v-radio label="Todos" :value="null"/>
        <v-radio label="Sim" :value="true"/>
        <v-radio label="Não" :value="false"/>
      </v-radio-group>
      <v-radio-group v-model="filtros.sexo" class="checkbox_row" row dense label="Sexo">
        <v-radio label="Todos" :value="null"/>
        <v-radio label="Feminino" value="FEMININO"/>
        <v-radio label="Masculino" value="MASCULINO"/>
      </v-radio-group>
      <v-radio-group v-model="filtros.ultimaVisita" class="checkbox_row" row dense
                     label="Ordenar por tempo de visita mais recente?">
        <v-radio label="Sim" :value="true"/>
        <v-radio label="Não" :value="false"/>
      </v-radio-group>
      <buscar-municipio :municipio-id="filtros.municipioId"
                        :estado-id="filtros.estadoId"
                        return-object
                        @emitirSelecionarEstado="selecionarEstado"
                        @emitirSelecionarCidade="selecionarMunicipio"
      />
      <mes-input
          v-model="filtros.mesAniversario"
          name-date="mesAniversario"
          style="width: 230px"
      >
        <template v-slot:label-date>
          Aniversariantes do mês
        </template>
      </mes-input>
    </div>
    <div class="row-bottom">
      <v-tooltip top>
        <template v-slot:activator={on}>
          <v-btn
              v-on="on"
              id="botaoDownload"
              class="mr-5"
              icon
              @click="gerarRelatorio(true)">
            <v-icon>mdi-file-download</v-icon>
          </v-btn>
        </template>
        Baixar .PDF
      </v-tooltip>
      <v-btn
          id="botaoGerar"
          color="primary"
          depressed
          @click="gerarRelatorio(false)">
        Gerar relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import BuscarMunicipio from '@/views/components/BuscarMunicipio.vue'
import MesInput from '@/views/components/MesInput.vue'

export default {
    name: 'RelatorioPacienteGeral',
    components: {MesInput: MesInput, BuscarMunicipio},
    data() {
        return {
            filtros: {
                ortodontia: null,
                implante: null,
                municipioId: null,
                estadoId: null,
                sexo: null,
                mesAniversario: null,
                ultimaVisita: false,
            },
            municipio: {},
            estado: {}
        }
    },
    methods: {
        selecionarEstado(estadoId) {
            this.filtros.estadoId = estadoId
        },
        selecionarMunicipio(municipioId) {
            this.filtros.municipioId = municipioId
        },
        async gerarRelatorio(baixar) {
            await this.$store.dispatch(actionTypes.RELATORIOS.GERAR_RELATORIO_PACIENTES, {
                filtros: this.filtros,
                baixar: baixar
            })
        }
    }
}
</script>

<style scoped lang="stylus">

.container-relatorio-filtros
  width 100%
  display flex
  flex-direction column
  justify-content space-between

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  padding-right 20px
  text-align right

.text-selecione
  padding-top 10px
  padding-left 10px
  border-bottom 1px solid #ddd

  span
    font-weight bold

.container-relatorio-interno
  padding 20px

</style>